import type { OutlookSpace, TimeStreamProject } from 'owa-timestream-types';
import updateProjectWithPatch from './updateProjectWithPatch';

export default function updateProject(project: TimeStreamProject, space: OutlookSpace) {
    updateProjectWithPatch(project, space);

    // From OutlookSpace itself
    project.outlookSpaceId = space.id;
    project.outlookSpaceKey = space.key;
    project.createdDateTime = space.createdDateTime;
    project.lastModifiedDateTime = space.lastModifiedDateTime;

    // assets are not copied by this function
    return project;
}
